import Vue from 'vue'
import Router from 'vue-router'
import CvView from './views/CvView.vue'

Vue.use(Router)

export default new Router({
	base: '/',
	mode: 'history',
	linkActiveClass : 'routerLink--active',
	linkExactActiveClass : 'routerLink--exactActive',
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
	routes: [
		{	path: '*',
			name: 'CvView',
			component: CvView,
		},
	]
})
